<template>
  <div class="position-relative">
    <div class="workspace-title">
      Dashboard
    </div>
    <template v-if="isTeamLoaded">
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import statuses from '@/helpers/statuses'

export default {
  name: 'Dashboard',

  computed: {
    ...mapGetters([
      'teams',
      'teamsLoading'
    ]),

    isTeamLoaded() {
      return this.teamsLoading === statuses.LOADED
    }
  }
}
</script>
